import { combineReducers } from 'redux';
import wordPair from './wordPair';
import showRemembered from './showRemembered';
import showTranslation from './showTranslation';
import errorMessage from './errorMessage';
import bearerToken from './bearerToken';
import { WordPair } from "../models";

export interface RootState {
  wordPair: WordPair|null;
  showRemembered: boolean;
  showTranslation: boolean;
  errorMessage: string;
  bearerToken: string;
}

const reducer = combineReducers<RootState>({
  wordPair,
  bearerToken,
  showRemembered,
  showTranslation,
  errorMessage,
});

export default reducer;
